<div class="container-custom">
  <div class="table-header">
    <h2 class="title">Lote de cabotaje</h2>
  </div>
  <div class="container-grid">
    <div class="grid-first">
      <label for="noLote" class="form-label">No. de lote</label>
      <input
        type="text"
        id="noLote"
        class="form-control"
        [value]="lote.registry_number"
        disabled
      />
    </div>
    <div>
      <label for="nombreLote" class="form-label">Nombre del lote</label>
      <input
        type="text"
        id="nombreLote"
        class="form-control"
        [value]="lote.customer_lot_number"
        disabled
      />
    </div>
    <div>
      <label for="material" class="form-label">Material</label>
      <input
        type="text"
        id="material"
        class="form-control"
        [value]="lote.material_name"
        disabled
      />
    </div>
    <div class="grid-first">
      <label for="cliente" class="form-label">Cliente</label>
      <input
        type="text"
        id="cliente"
        class="form-control"
        [value]="lote.client_name"
        disabled
      />
    </div>
    <div>
      <label for="razonSocial" class="form-label">Razón social</label>
      <input
        type="text"
        id="razonSocial"
        class="form-control"
        [value]="customerBusinessName"
        disabled
      />
    </div>
    <div class="grid-span2">
      <label for="domicilioRazonSocial" class="form-label">Domicilio razón social</label>
      <input
        type="text"
        id="domicilioRazonSocial"
        class="form-control"
        [value]="lote.address_business"
        disabled
      />
    </div>
    <div class="grid-first">
      <label for="toneladas" class="form-label">Toneladas</label>
      <input
        type="text"
        id="toneladas"
        class="form-control"
        [value]="lote.tonnage | number : '1.3-3'"
        disabled
      />
    </div>
    <div>
      <label for="toneladasEntrada" class="form-label">Toneladas de entrada</label>
      <input
        type="text"
        id="toneladasEntrada"
        class="form-control"
        [value]="lote.input_tons | number : '1.3-3'"
        disabled
      />
    </div>
    <div>
      <label for="toneladasSalida" class="form-label">Toneladas de salida</label>
      <input
        type="text"
        id="toneladasSalida"
        class="form-control"
        [value]="lote.output_tons | number : '1.3-3'"
        disabled
      />
    </div>
    <div>
      <label for="toneladasRestantes" class="form-label">Toneladas restantes</label>
      <input
        type="text"
        id="toneladasRestantes"
        class="form-control"
        [value]="lote.remaining_tons | number : '1.3-3'"
        disabled
      />
    </div>
    <div class="mb-3" *ngIf="lote.quantity_pieces">
      <label for="bl-lote" class="form-label">Piezas restantes</label>
      <input
        type="text"
        id="bl-lote"
        class="form-control"
        [value]="lote.remaining_pieces"
        disabled
      />
    </div>
    <div style="padding-top: 27px;">
      <app-tons-per-yard
        [module]="3"
        [batchId]="bachId"
      ></app-tons-per-yard>
    </div>
  </div>
  <h2 class="title title-midle">
      Registro de operaciones de cabotaje
  </h2>
  <nav class="movimiento">
    <li [routerLink]="['entry', bachId]" routerLinkActive="active">
      <a>Registro de entrada</a>
    </li>
    <li [routerLink]="['entry-list', bachId]" routerLinkActive="active">
      <a>Listado de entradas</a>
    </li>
    <li [routerLink]="['output', bachId]" routerLinkActive="active">
      <a>Registro de salida</a>
    </li>
    <li [routerLink]="['output-list', bachId]" routerLinkActive="active">
      <a>Listado de salidas</a>
    </li>
  </nav>
  <router-outlet></router-outlet>
</div>
